
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function FooterEmailSignupButton_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Email Signup",
	"eventCategory": "Signup",
	"eventAction": "Signup",
    "eventLabel": "SignUp: Footer"
} );
}

export function QuickLinksText_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: Quick Links Footer"
} ); 
}

export function textContactlink_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: Contact Link Text Footer"
} ); 
}

export function AdventureQuickLinkText_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: Adventure QuickLinks Footer"
} ); 
}

export function FacebookLogoImage_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Click",
	"eventCategory": "OutboundLink",
	"eventAction": "Click",
    "eventLabel": "Outbound: Facebook Logo Footer"
});
}

export function InstagramLogoImage_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Click",
	"eventCategory": "OutboundLink",
	"eventAction": "Click",
    "eventLabel": "Outbound: Instagram Logo Footer"
});
}